// Хозяйство
export const FARMING = '/farming';

// Отчетность

export const REPORT = '/report';

export const FREE = '/free';

export const MORTALITY = '/mortality';

// Вакцинация

export const VACCIANTION = '/vaccination';
export const REGISTRY = '/registry';
export const TASK = '/task';
export const CONTROL = '/control';
export const PROTOCOLS = '/protocols';
export const ARCHIVE = '/archive';

// Аптека

export const PHARMACY = '/pharmacy';
export const MONITORING = '/monitoring';
export const DICTIONARIES = '/dictionaries';

// Патологоанатомия

export const PATHOLOGY = '/pathology';
export const ACTS = '/acts';
